import React from 'react';
import fileDownload from 'js-file-download';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Grid from '../../../components/base/Grid/Grid';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { dateFormatter, smevCheckFormatter } from '../../../utils/formatters';
import { smevCheckAllApplication, smevCheckApplication } from '../actions';
import { successNotification } from '../../Notifications/notificationDecorator';
import { responseLogWithNotification } from '../../../utils/utils';
import { getApplicationData } from '../reducer';

export default function MobileSmevDialog(props) {
  const {
    currentApplication = null,
    handleClose = () => {},
    loadApplication = () => {},
    loadData = () => {},
  } = props;

  const { smevCheckList = [] } = useSelector(getApplicationData);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const columns = [
    {
      dataField: 'type',
      text: 'Проверка',
      disableSort: true,
      headerClassName: 'check-type-name',
      formatter: smevCheckFormatter,
    },
    {
      dataField: 'type',
      text: 'Поставщик информации',
      disableSort: true,
      formatter: t => (t && t.source ? t.source : ''),
    },
    {
      dataField: 'responded_at',
      text: 'Дата ответа',
      disableSort: true,
      formatter: dateFormatter,
    },
    {
      dataField: 'report',
      text: 'Отчет',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'report-column-data',
      formatter: () => <Icons className="grid-button" icon="paper" customIcon />,
    },
    {
      dataField: 'last_smev_log',
      text: 'Запрос',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_request, `${data.type.name}_request.xml`)} icon="xml_report" customIcon />,
    },
    {
      dataField: 'last_smev_log',
      text: 'Ответ',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_response, `${data.type.name}_response.xml`)} icon="xml_report" customIcon />,
    },
    {
      dataField: 'id',
      text: 'Обновить',
      disableSort: true,
      headerClassName: 'reload-column',
      dataClassName: 'reload-column-data',
      formatter: id => <Icons onClick={handleRunCheck(id)} className="grid-button" icon="update" customIcon />,
    },
  ];

  const handleRunCheck = checkId => () => {
    dispatch(smevCheckApplication({ checkId })).then(() => {
      loadApplication();
      loadData();
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(response => responseLogWithNotification(response, 'Повторная проверка', response?.message || ''));
  };

  const handleSmevCheck = () => {
    dispatch(smevCheckAllApplication(currentApplication?.id)).then(() => {
      loadApplication();
      loadData();
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };

  return (
    <Dialog
      className="mobile-smev-modal"
      onClose={handleClose}
      size="xl"
      open
    >
      <DialogTitle header="Перечень запросов СМЭВ/СМЭВ СПб" />
      <DialogContent className="msm-content">
        <Grid
          emptyText={formatMessage({ id: 'empty.data' })}
          data={smevCheckList}
          columns={columns}
          name="profile-list"
        />
      </DialogContent>
      <DialogFooter className="msm-footer">
        <Button variant="secondary" onClick={handleClose}>Закрыть</Button>
        <Button onClick={handleSmevCheck}>
          Запустить проверки
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
